import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/_organization/events/")({
  component: () => <Navigate to="/events/all-events" />,
})
